function pluralize(count, singularStr, pluralStr) {
  if (count === 1) return singularStr;
  return pluralStr || `${singularStr}s`;
}

export { pluralize };
